'use client';
import React from 'react';
import Image from 'next/image';

export default function HeroSection() {
  return (
    <section id="hero" className="hero section dark-background">
      <Image
        src="/assets/img/hero-bg.jpg"
        alt="Smart service"
        width={1200}
        height={600}
        priority
      />

      <div className="container">
        <div
          className="row justify-content-center text-center"
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <div className="col-xl-6 col-lg-8">
            <h2>
              Smart Service<span>.</span>
            </h2>
            <p>Trusted Manpower Partner for Government & Private Projects</p>
          </div>
        </div>

        <div
          className="row gy-4 mt-5 justify-content-center"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          {[
            { icon: 'bi-person-raised-hand', label: 'Man Power Supply', delay: 300 },
            { icon: 'bi-shield-fill', label: 'Security Staff', delay: 400 },
            { icon: 'bi-recycle', label: 'Cleaning Staff', delay: 500 },
            { icon: 'bi-hospital', label: 'Hospital Staff', delay: 600 },
            { icon: 'bi-cone-striped', label: 'Industrial Staff', delay: 700 },
          ].map((item, index) => (
            <div
              className="col-xl-2 col-md-4"
              data-aos="fade-up"
              data-aos-delay={item.delay}
              key={index}
            >
              <div className="icon-box">
                <i className={`bi ${item.icon}`}></i>
                <h3>
                  <a href="">{item.label}</a>
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
